import React from "react";

import { useNavigate, useParams, useToggleNavs, useTranslation } from "utils";

import { Col, FarmFieldCard, Link, MainPage, NavigationHeader, Row } from "components";

export const SplitSuccess = () => {
  const { t } = useTranslation(["farm", "meta"]);
  const { field1Id, field2Id } = useParams();
  const navigate = useNavigate();
  useToggleNavs(false, true);

  return (
    <MainPage dataTestId="split-success-page" loading={false} pageName={"splitSuccess"} containerClass="tiny">
      <NavigationHeader title="" link="/farm" mixpanelText={t("farm:fieldSplitting.fieldSplitSuccess.skip")} />
      <Row>
        <Col>
          <h1 className="center margin-bottom-100">{t("farm:fieldSplitting.fieldSplitSuccess.heading")}</h1>
          <p className="center margin-bottom-400">{t("farm:fieldSplitting.fieldSplitSuccess.description")}</p>
        </Col>
      </Row>
      <section className="container tiniest">
        <h4 className="center margin-bottom-175">{t("farm:fieldSplitting.fieldSplitSuccess.updateFieldData")}</h4>
        <Row justify="center">
          <Col>
            <FarmFieldCard dataTestId="split-success-page-field-card-1" fieldId={field1Id || ""} onClick={() => navigate(`/all-fields/field/${field1Id}`)} />
          </Col>
        </Row>
        <Row className="margin-bottom-150" justify="center">
          <Col>
            <FarmFieldCard dataTestId="split-success-page-field-card-2" fieldId={field2Id || ""} onClick={() => navigate(`/all-fields/field/${field2Id}`)} />
          </Col>
        </Row>
        <Row justify="center">
          <Col className="center">
            <Link to="/all-fields" dataTestId="split-success-page-skip-link" mixpanelText={t("farm:fieldSplitting.fieldSplitSuccess.skip")}>
              {t("farm:fieldSplitting.fieldSplitSuccess.skip")}
            </Link>
          </Col>
        </Row>
      </section>
    </MainPage>
  );
};
